import React, { ChangeEvent, FocusEvent, MouseEvent } from 'react'
import { IIshikawaCategory, IIshikawaDiagram } from '../types'
import { CausesRoot } from '../style'

/**
 * Redenriza a informações da parte de baixo do diagrama
 * @param diagram - objeto contendo o diagrama selecionado
 */
interface IGetRootCauses{
    diagram: IIshikawaDiagram
    category: string
    handleChange: (e: ChangeEvent<HTMLInputElement>) => void
    handleClickCause: (
        event: MouseEvent<HTMLSpanElement>,
        category: IIshikawaCategory,
        causeIndex: number,
        value: string
    ) => void
}
export function GetRootCauses({
    diagram,
    category,
    handleChange,
    handleClickCause,
}: IGetRootCauses) {
    let objCategory =
        diagram &&
        diagram.categories
            .filter((cat: IIshikawaCategory) => cat.title === category)
            .find((c: IIshikawaCategory) => !!c)
    let causes = objCategory.causes?.map((rootCause: string, index: number) => {
        return (
            <GetRootCause
                index={index}
                editing={false}
                value={rootCause}
                category={objCategory}
                handleChange={handleChange}
                handleClickCause={handleClickCause}
            />
        )
    })
    return <CausesRoot>{causes}</CausesRoot>
}
/**
 * Containner do texto de causa
 * @TODO Foi iniciado o evento para transformar em input para editar ou incluir mas ainda inacabado
 * @param index
 * @param editing
 * @param value
 */
interface IGetRootCause {
    index: number
    editing: boolean
    value: string
    category: IIshikawaCategory
    handleChange: (e: ChangeEvent<HTMLInputElement>) => void
    handleClickCause: (
        event: MouseEvent<HTMLSpanElement>,
        category: IIshikawaCategory,
        causeIndex: number,
        value: string
    ) => void
}
export function GetRootCause({
    index,
    editing,
    value,
    category,
    handleChange,
    handleClickCause
}: IGetRootCause) {
    return (
        <div key={index}>
            {editing ? (
                <input
                    type="text"
                    value={value}
                    onChange={handleChange}
                    autoFocus
                />
            ) : (
                <span
                    style={{
                        margin: '4px',
                        width: '161px',
                        lineBreak: 'anywhere'
                    }}
                    key={`root_causes_${value}_${index}`}
                    onDoubleClick={(e: MouseEvent<HTMLSpanElement>) =>
                        handleClickCause(e, category, index, value)
                    }
                >
                    {value}
                </span>
            )}
        </div>
    )
}
